import React from 'react';

export default function SessionStatus({ loading, error, onRetry, onLogout }) {
    return <main className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
        {loading ? <p role="status">Comprobando tu sesión…</p> : <section className="w-full max-w-md rounded-xl border bg-card p-6 shadow-sm">
            <h1 className="text-xl font-semibold mb-3">No se ha podido conectar con Espuma</h1>
            <p role="alert" className="text-muted-foreground">{error}</p>
            <p className="mt-3 text-sm text-muted-foreground">Tu sesión se conserva. Puedes volver a intentarlo.</p>
            <div className="flex gap-3 mt-6">
                <button type="button" className="rounded-md bg-primary text-primary-foreground px-4 py-2 font-medium" onClick={onRetry}>Reintentar conexión</button>
                <button type="button" className="rounded-md border px-4 py-2" onClick={onLogout}>Cerrar sesión</button>
            </div>
        </section>}
    </main>;
}
